import CampaignListModel from './CampaignListModel'
import CampaignModel from './CampaignModel'
import ExtraCampaignGateway from './ExtraCampaignGateway'
import UnassignedEmailsModel from './UnassignedEmailsModel'
import EmailsModel from './EmailsModel'

export default class ExtraCampaignService {
  constructor (extraCampaignGateway) {
    this.ExtraCampaignGateway = extraCampaignGateway || new ExtraCampaignGateway()

    this.createAlternativeCampaign = this.createAlternativeCampaign.bind(this)
    this.allowedNamesAlternativeCampaigns = this.allowedNamesAlternativeCampaigns.bind(this)
    this.allAlternativeCampaigns = this.allAlternativeCampaigns.bind(this)
    this.closeAlternativeCampaign = this.closeAlternativeCampaign.bind(this)
    this.getAlternativeCampaign = this.getAlternativeCampaign.bind(this)
    this.sendEmailsAlternativeCampaign = this.sendEmailsAlternativeCampaign.bind(this)
    this.codesResetAlternativeCampaign = this.codesResetAlternativeCampaign.bind(this)
    this.codesDeleteAlternativeCampaign = this.codesDeleteAlternativeCampaign.bind(this)
    this.deleteManyAlternativeCampaign = this.deleteManyAlternativeCampaign.bind(this)
    this.resetManyAlternativeCampaign = this.resetManyAlternativeCampaign.bind(this)
    this.getUnassignedAlternativeCampaign = this.getUnassignedAlternativeCampaign.bind(this)
    this.getAlternativeEmailsHistory = this.getAlternativeEmailsHistory.bind(this)
    this.getAlternativeIndividualEmails = this.getAlternativeIndividualEmails.bind(this)
    this.updateExtraCurrentEmailTemplate = this.updateExtraCurrentEmailTemplate.bind(this)
    this.getExtraCurrentEmailTemplate = this.getExtraCurrentEmailTemplate.bind(this)
    this.alternativeCampaignAddEmail = this.alternativeCampaignAddEmail.bind(this)
  }

  updateExtraCurrentEmailTemplate (query) {
    return this.ExtraCampaignGateway
      .updateExtraCurrentEmailTemplate(query)
      .then(response => response)
  }

  alternativeCampaignAddEmail (query) {
    return this.ExtraCampaignGateway
      .alternativeCampaignAddEmail(query)
      .then(response => response)
  }

  getExtraCurrentEmailTemplate (params) {
    return this.ExtraCampaignGateway
      .getExtraCurrentEmailTemplate(params)
      .then(response => response)
  }

  getAlternativeCampaign (params) {
    return this.ExtraCampaignGateway
    .getAlternativeCampaign(params)
    .then(response => new CampaignModel(response))
  }

  getAlternativeIndividualEmails (params) {
    return this.ExtraCampaignGateway
    .getAlternativeIndividualEmails(params)
    .then(response => response.map(item => EmailsModel(item[0])))
  }

  getUnassignedAlternativeCampaign (params) {
    return this.ExtraCampaignGateway
    .getUnassignedAlternativeCampaign(params)
    .then(response => response.map(item => UnassignedEmailsModel(item)))
  }

  getAlternativeEmailsHistory (params) {
    return this.ExtraCampaignGateway
    .getAlternativeEmailsHistory(params)
    .then(response => response.map(item => EmailsModel(item[0])))
  }

  closeAlternativeCampaign (query) {
    return this.ExtraCampaignGateway
      .closeAlternativeCampaign(query)
      .then(response => response)
  }

  allAlternativeCampaigns () {
    return this.ExtraCampaignGateway
      .allAlternativeCampaigns()
      .then(response => response.map(campaign => new CampaignListModel(campaign)))
  }

  allowedNamesAlternativeCampaigns () {
    return this.ExtraCampaignGateway
      .allowedNamesAlternativeCampaigns()
      .then(response => response.map((item, idx) => ({ key: idx, title: item })))
  }

  createAlternativeCampaign (query) {
    return this.ExtraCampaignGateway
      .createAlternativeCampaign(query)
      .then(() => ({ status: 'Success' }))
  }

  sendEmailsAlternativeCampaign (query) {
    return this.ExtraCampaignGateway
      .sendEmailsAlternativeCampaign(query)
      .then(response => response)
  }

  codesResetAlternativeCampaign (query) {
    return this.ExtraCampaignGateway
      .codesResetAlternativeCampaign(query)
      .then(response => response)
  }

  codesDeleteAlternativeCampaign (query) {
    return this.ExtraCampaignGateway
      .codesDeleteAlternativeCampaign(query)
      .then(response => response)
  }

  deleteManyAlternativeCampaign (query) {
    return this.ExtraCampaignGateway
      .deleteManyAlternativeCampaign(query)
      .then(response => response)
  }

  resetManyAlternativeCampaign (query) {
    return this.ExtraCampaignGateway
      .resetManyAlternativeCampaign(query)
      .then(response => response)
  }
}



// WEBPACK FOOTER //
// ./src/api/extra-campaigns/ExtraCampaignService.js